/**
 * Core components.
 *
 * @module postprocessing/core
 */

export { EffectComposer } from "./EffectComposer.js";



//////////////////
// WEBPACK FOOTER
// ./~/postprocessing/src/core/index.js
// module id = 31
// module chunks = 0